export const PROMPT_P06 = (sponsorProduct = 'Sikaflex-2c NS EZ Mix + Sika Backer Rod') => `
Analyze for DAMAGED / UNSEALED JOINTS (ACI 302.1R).
Visual: sealant condition (missing, adhesion failure, cohesion failure, hardened),
joint faces (spalled, chipped), faulting (differential displacement), foreign objects.
Return ONLY this JSON:
{
  "pathology_id": "p06_joints",
  "pathology_name": { "es": "Juntas dañadas o sin sellar", "en": "Damaged or unsealed joints" },
  "norm": "ACI 302.1R",
  "confidence": 85,
  "requires_additional_input": false,
  "joint_type": "expansion|contraction|construction|isolation|unknown",
  "sealant_condition": "missing|adhesion_failure|cohesion_failure|hardened|adequate",
  "joint_faces_condition": "spalled|chipped|sound",
  "faulting_present": false,
  "root_cause": { "es": "...", "en": "..." },
  "severity": "low|medium|high|critical",
  "urgency": "deferred|planned|immediate|emergency",
  "repair": {
    "procedure": {
      "es": ["1. Extraer sellador deteriorado con router de juntas","2. Limpiar caras con chorro de arena o disco abrasivo","3. Instalar backer rod PE celda cerrada (relación ancho:profundidad 2:1)","4. Aplicar sellador poliuretano bicomponente en dos tiempos"],
      "en": ["1. Remove deteriorated sealant with joint router","2. Clean faces with sandblasting or abrasive disc","3. Install closed-cell PE backer rod (width-to-depth ratio 2:1)","4. Apply two-component polyurethane sealant in two-step process"]
    },
    "norm_reference": "ACI 302.1R-15 Sec. 9.5; ACI 504R"
  },
  "materials": {
    "generic": { "es": "Sellador PU Shore A 25–35; backer rod PE", "en": "PU sealant Shore A 25–35; PE backer rod" },
    "premium": { "product": "${sponsorProduct}", "brand": "Sika", "note": { "es": "Movimiento admisible ±25%; resistente tráfico vehicular", "en": "Allowable movement ±25%; vehicle traffic resistant" } }
  },
  "linkedin_draft": { "es": "..." },
  "disclaimer": { "es": "Dimensionamiento de juntas requiere verificación con planos estructurales.", "en": "Joint dimensioning requires verification with structural drawings." }
}`;
